export enum ClientLoginStage {
  "Welcome" = 0,
  "InspirationOverview" = 1,
  "Selection" = 2,
  "Finalize" = 3,
}

export enum MouseButton {
  Left = 0,
  Middle = 1,
  Right = 2,
}

export enum VideoType {
  Introduction = 1,
  Selection = 2,
  Cart = 3,
}

export enum UserType {
  Client = 0,
  CoClient = 1
}

export enum RuleAction {
  Remove = 0,
  Add = 1
}

export enum SessionType {
  Update,
  Logout
}

export enum AreaType {
  Area = 0,
  Inspiration = 1,
  TrueValue = 2
}
